import { render, staticRenderFns } from "./MarkdownToolBox.vue?vue&type=template&id=56901f87"
import script from "./MarkdownToolBox.vue?vue&type=script&lang=js"
export * from "./MarkdownToolBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports